import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { obituaryService } from 'config/services';

import { HttpError } from 'helpers/http';

interface Props {
  uuid?: string;
  isCreated?: boolean;
  fun: () => void;
}

export const Payment = (data: Props) => {
  const [signature, setSignature] = useState<any>({});
  const { uuid } = data;
  const { data: signatureData, refetch: refetchSignature } = useQuery<any, HttpError>({
    queryFn: () => obituaryService.getSignature(uuid),
    enabled: data.isCreated,
    cacheTime: 0,
    staleTime: 0,
  });

  const handleSubmit = (event: any) => {
    //event.preventDefault();
  };

  useEffect(() => {
    if (signatureData) {
      console.log(signatureData, 'useEffectSignature');
      setSignature(signatureData);
      data.fun();
    }
  }, [signatureData]);

  return (
    <>
      {signatureData && (
        <form
          action={process.env.PAYMENT_URL}
          onSubmit={handleSubmit}
          method="POST"
          style={{ display: 'none' }}
          id="paymentMethod"
        >
          <input name="Version" type="text" value="1" />
          <input name="MerchantID" type="text" value={signatureData.MerchantID} />
          <input name="TerminalID" type="text" value={signatureData.TerminalID} />
          <input name="TotalAmount" type="text" value={signatureData.TotalAmount} />
          <input name="Currency" type="text" value="977" />
          <input name="locale" type="text" value="bs" />
          <input type="text" name="PurchaseTime" value={signatureData.PurchaseTime} />
          <input name="OrderID" type="text" value={signatureData.OrderID} />
          <input name="PurchaseDesc" type="text" value="tran tvrgrt" />
          <input
            name="Signature"
            type="text"
            value={signatureData.Signature}
            //value="e74ow/0K2RgE3a61Xb1YrkLfsbOYYhsyX4EI8qCsz6MyjOH26BFHM5FxDl0P8eN1B5DrlzQuo3C8eTIX4QvfRPsjQGDuFTCwe1M4iLBdcKuQNoFuctTMCfRKsOxwFvD+CZfLGq+i/006v/kf+0wN2gkhDjdH5gje0kbziKEwVLM="
          />
          <input type="submit" />
        </form>
      )}
    </>
  );
};

export default Payment;
